import {
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  Input,
  TemplateRef
} from '@angular/core';
import { ViewLoadState } from '@ppl/domain';
import { AsyncState } from '@ppl/store';

@Component({
    selector: 'ppl-async-view',
    templateUrl: './async-view.component.html',
    styleUrls: ['./async-view.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AsyncViewComponent {

  @Input() state: ViewLoadState;

  @ContentChild('asyncViewFetched') fetchedTemplate!: TemplateRef<any>;
  @ContentChild('asyncViewFetching') fetchingTemplate: TemplateRef<any>;
  @ContentChild('asyncViewError') errorTemplate: TemplateRef<any>;
  @ContentChild('asyncViewUnavailable') unavailableTemplate: TemplateRef<any>;

  ViewLoadState = ViewLoadState;
}

export const DEFAULT_ASYNC_STATE_TO_VIEW_LOAD_STATE_MAP = {
  [AsyncState.IDLE]: ViewLoadState.NO_DATA,
  [AsyncState.FETCHING]: ViewLoadState.FETCHING,
  [AsyncState.FETCHED]: ViewLoadState.FETCHED,
  [AsyncState.ERROR]: ViewLoadState.ERROR,
};
